import { EmployeeOverview } from "../types/staff-profile.types";

export const employeeOverviewMock: EmployeeOverview = {
  employeeId: "EMP00123",
  employeeName: "Muthumeena R",
  status: "ACTIVE",
  joinedDate: "01 Jul 2021",
  experience: "3 Years 11 Months of Experience",
  currentRole: "Senior Software Engineer",
  currentPosition: "Technical Lead",
  currentCtc: "₹14,50,000",
  currentClient: "TechNova Solutions",
  project: "Engineering",
  careerHistory: [    
    
  { id: "2024-salary-2", year: "2024", date: "01 Sep 2024", eventType: "SALARY REVISION", role: "Senior Software Engineer", position: "Technical Lead", ctc: "₹14,50,000", client: "TechNova Solutions", description: "Salary Revised" },

  { id: "2024-salary-1", year: "2024", date: "01 Mar 2024", eventType: "SALARY REVISION", role: "Technical Lead", position: "Technical Lead", ctc: "₹11,00,000", client: "TechNova Solutions", description: "Salary Revised" },

  { id: "2023-role", year: "2023", date: "01 Dec 2023", eventType: "ROLE CHANGE", role: "Senior Developer", position: "Technical Lead", ctc: "₹9,50,000", client: "Innovative Tech", description: "Role Changed" },

  { id: "2023-salary", year: "2023", date: "01 Oct 2023", eventType: "SALARY REVISION", role: "Senior Developer", position: "Senior Developer", ctc: "₹8,80,000", client: "Innovative Tech", description: "Salary Revised" },

  { id: "2023-role-position", year: "2023", date: "01 Apr 2023", eventType: "ROLE & POSITION CHANGE", role: "Senior Developer", position: "Senior Developer", ctc: "₹7,80,000", client: "Innovative Tech", description: "Role & Position Changed" },

  { id: "2022-salary-2", year: "2022", date: "01 Dec 2022", eventType: "SALARY REVISION", role: "Developer", position: "Developer", ctc: "₹6,80,000", client: "Innovative Tech", description: "Salary Revised" },

  { id: "2022-client", year: "2022", date: "01 Aug 2022", eventType: "CLIENT CHANGE", role: "Developer", position: "Developer", ctc: "₹6,20,000", client: "Innovative Tech", description: "Client Changed" },

  { id: "2022-salary", year: "2022", date: "01 Feb 2022", eventType: "SALARY REVISION", role: "Developer", position: "Developer", ctc: "₹5,80,000", client: "Global Soft", description: "Salary Revised" },

  { id: "2021-role", year: "2021", date: "01 Dec 2021", eventType: "ROLE CHANGE", role: "Junior Developer", position: "Developer", ctc: "₹4,00,000", client: "Global Soft", description: "Role & Position Changed" },

  { id: "2021-salary-1", year: "2021", date: "01 Dec 2021", eventType: "SALARY REVISION", role: "Junior Developer", position: "Developer", ctc: "₹4,50,000", client: "Global Soft", description: "Salary Revised" },

  { id: "2021-salary-2", year: "2021", date: "15 Nov 2021", eventType: "SALARY REVISION", role: "Junior Developer", position: "Developer", ctc: "₹5,00,000", client: "Global Soft", description: "Salary Revised" },

  { id: "2021-joined", year: "2021", date: "01 Jul 2021", eventType: "JOINED", role: "Training Developer", position: "Junior Developer", ctc: "₹3,50,000", client: "Global Soft", description: "Joined the organization" },

  ],
};
